import { SelectedShippingRateSchema } from "@redotech/redo-fulfillment-carrier-common/carriers-and-services";
import { consolidationCartonPurchasedLabelSchema } from "@redotech/redo-fulfillment-operations-common/consolidation-carton-label";
import { consolidationCartonLabelInputSchema } from "./consolidation-carton-label-common";

export const purchaseConsolidationCartonLabel = {
  name: "purchaseConsolidationCartonLabel" as const,
  mutates: true,
  input: consolidationCartonLabelInputSchema.extend({
    shipmentRate: SelectedShippingRateSchema,
  }),
  output: consolidationCartonPurchasedLabelSchema,
};
